import Vue from "vue";
import VueCryptoJs from "vue-cryptojs";

Vue.use(VueCryptoJs);
